/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LeaveOrganizationResponse } from '../../models/leave-organization-response';

export interface DeleteSessionMembership$Params {
}

export function deleteSessionMembership(http: HttpClient, rootUrl: string, params?: DeleteSessionMembership$Params, context?: HttpContext): Observable<StrictHttpResponse<LeaveOrganizationResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteSessionMembership.PATH, 'delete');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LeaveOrganizationResponse>;
    })
  );
}

deleteSessionMembership.PATH = '/api/v1/session/membership';
